<!--
 * @Description: 日程会场列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-06-23 12:25:55
 * @LastEditors: 山淑兰
 -->
<template>
  <div class="roomlist">
    <div class="loading" v-if="loading">
      <van-loading color="#3b82f6" vertical size="30px" text-size="16px"
        >加载中...</van-loading
      >
    </div>

    <div v-else>
      <template v-if="$i18n.locale === 'zh-CN'">
        <ul
          class="meetinglist"
          v-for="item in datas"
          :key="item.roomid"
        >
          <li>
            <div class="meeting-info" @click="toLinkList(item.roomid, item.dateid)">
              <div class="meeting-title">
                {{ item.roomtitle }}
              </div>
              <div class="meeting-time">
                 <van-cell
                  icon="underway-o"
                  :value="item.prodate + ' ' +item.starttime + '-' + item.endtime"
                  class="forumDate-time"
                />
              </div>
              <div class="meeting-add">
                <van-cell
                  :title="item.roomname"
                  icon="location-o"
                  class="meetingTitle"
                />
              </div>
            </div>
            <div class="meeting-icon" v-if="item.roomurl!=null">
              <a :href="item.roomurl" target="_top">
                <img src="../../../assets/creame2.png">  
                <p>点击观看直播</p>
              </a>
            </div>
          </li>
        </ul>
      </template>

      <template v-else>
        <ul
          class="meetinglist"
          v-for="item in datas"
          :key="item.roomid"
        >
          <li>
            <div class="meeting-info" @click="toLinkList(item.roomid, item.dateid)">
              <div class="meeting-title">
                {{ item.roomentitle }}
              </div>
              <div class="meeting-time">
                 <van-cell
                  icon="underway-o"
                  :value="item.prodate + ' ' +item.starttime + '-' + item.endtime"
                  class="forumDate-time"
                />
              </div>
              <div class="meeting-add">
                <van-cell
                  :title="item.roomenname"
                  icon="location-o"
                  class="meetingTitle"
                />
              </div>
            </div>
            <div class="meeting-icon" v-if="item.roomurl!=null">
              <a :href="item.roomurl" target="_top">
                <img src="../../../assets/creame2.png">  
                <p>点击观看直播</p>
              </a>
            </div>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  neme: 'place',
  components: {},
  data() {
    return {
      loading: false,
      datas: [],
      m: '',
      dateid: 0,
      roomid: 0,
      language: '',
      search: '',
	  language: 0, //0中文，1英文
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.dateid != from.query.dateid && to.query.dateid) {
        this.dateid = to.query.dateid
        this.init()
      }
    },
  },
  created() {
	  this.language = this.$route.query.language
    if (this.$route.query) {
      this.dateid = this.$route.query.dateid
      this.language = this.$route.query.language
      this.init()
    }
  },
  methods: {
    async init() {
      try {
        this.loading = true
        const {
          m,
          dateid = this.dateid,
          roomid = this.roomid,
          search = this.search,
        } = this.$route.query //获得路由的参数
        this.m = m

        const _params = Object.assign(
          { m, dateid, roomid },
          search ? { search } : {}
        ) //search 是空字符串 为false 有值是true

        const res = await this.$http.initScheduleInfo(_params)

        this.$emit('searchDatas', res.childens)
        console.log(res.childens)
        this.datas = res.RoomDateEntityList
        console.log('会场列表数据', this.datas)
		this.datas.forEach(item => {
			if (this.language == 1){
				if(item.prodate.indexOf('月')!=-1){
					item.prodate = item.prodate.replace('月','.')
				}
				if(item.prodate.indexOf('日')!=-1){
					item.prodate = item.prodate.replace('日',' ')
				}
			}
		})

        this.loading = false
      } catch (error) {
        console.error(error)
      }

      // this.$toast.clear(false); //关闭加载动画
    },

    /**
     * @description 进入到子路由 封装的方法
     * @param {Objcet} params 路由需要的参数
     */
    toLinkList(roomid, dateid, language) {
      const params = {
        roomid: roomid,
        dateid: dateid,
        language: this.language
      }
      const { m } = this.$route.query
      this.$router.push({
        path: '/meeting/scheduleList',
        query: { m, ...params },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.roomlist {
  margin-bottom: 80px;
  font-size: 26px;
  line-height: 1.5;
  padding: 0 20px 20px;
  .meetinglist{
    background: #fff;
    margin-top: 20px;
    padding: 20px;
    -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
    border-radius: 12px;
    li{
      display: flex;
      .meeting-date{
        width: 160px;
        padding: 10px 0 0 0;
        font-weight: bold;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-end;
        p{
          font-size: 42px;
          color: #1e293b;
        }
        p:last-child{
          font-size: 64px;
          color: #64748b;
          margin-top: 5px;
        }
      }
      .meeting-info{
        flex: 1;
        padding-right: 20px;
        padding-bottom: 10px;
        .meeting-title{
          margin-bottom: 10px;
        }
        .van-cell{
          padding: 10px 0;
          font-size: 26px;
          line-height: 1.5;
          .van-cell__left-icon{
            line-height: 40px;
            font-size: 28px;
          }
        }
      }
      .meeting-icon{
        width: 160px;
        padding-bottom: 20px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        a{
          color: #1e293b;
          display: block;
          text-align: center;
        }
        img{
          width: 70px;
          margin: 0 auto;
        }
        p{
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
    
  }
}
// .roomlist {
//   margin-bottom: 80px;
//   ul {
//     margin: 10px;
//     box-shadow: 0 2px 12px rgba(0,0,0,0.04);
//     margin-bottom: 20px;
//     background: #fff;
//     color: #000;
//     li {
//       padding: 10px;
//       .van-cell {
//         font-size: 28px;
//         line-height: 48px;
//         padding: 0px;
//         color: #000;
//         i {
//           font-size: 28px;
//           line-height: 48px;
//           height: 48px;
//           margin-right: 10px;
//         }
//         &:after {
//           border: 0;
//         }
//       }
//       .meetingTitle {
//         padding: 10px;
//         > i {
//           color: #3b82f6;
//           font-weight: bold;
//         }
//       }
//     }
//     .forum-date {
//       border-top: 1px solid #e2e8f0;
//       position: relative;
//       padding: 20px 62px 20px 20px;
    
//       .runicon {
//         font-size: 36px;
//         position: absolute;
//         right: 16px;
//         bottom: 48px;
//         color: #94a3b8;
//       }
//       .forumDate-time {
//         .van-cell__title {
//           flex: 2;
//         }
//         .van-cell__value {
//           flex: 7;
//           text-align: left;
//           font-size: 28px;
//           font-weight: bold;
//           color: #000;
//         }
//       }
//     }
//   }
// }
</style>
